import React from 'react';
export function CircleBackground() {
  return <div className="absolute inset-0 overflow-hidden z-0" data-id="element-90">
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-pink-100 opacity-50" data-id="element-91"></div>
      <div className="absolute -top-12 left-48 w-80 h-80 rounded-full bg-blue-100 opacity-50" data-id="element-92"></div>
      <div className="absolute top-40 -right-24 w-64 h-64 rounded-full bg-gray-100 opacity-50" data-id="element-93"></div>
      <div className="absolute -bottom-24 -left-12 w-72 h-72 rounded-full bg-blue-50 opacity-40" data-id="element-94"></div>
    </div>;
}